import { render, staticRenderFns } from "./SelectedPostItem.vue?vue&type=template&id=be6de334&"
import script from "./SelectedPostItem.vue?vue&type=script&lang=js&"
export * from "./SelectedPostItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports